/**
 * Traduz mensagens de erro técnicas do onboarding para linguagem comercial em PT-BR.
 * Esconde detalhes de constraint, tabela e SQL do usuário final.
 * O erro técnico original continua sendo logado via logger para fins de debug.
 */
export function getFriendlyOnboardingError(message?: string | null): string {
  const raw = (message || '').toString();
  const msg = raw.toLowerCase();

  if (!msg.trim()) {
    return 'Não foi possível criar sua empresa agora. Tente novamente em alguns instantes ou fale com o suporte.';
  }

  // Rate limit — preserva fluxo atual
  if (msg.includes('rate') || msg.includes('limite') || msg.includes('muitas tentativas')) {
    return 'Muitas tentativas em pouco tempo. Aguarde alguns instantes e tente novamente.';
  }

  // Duplicidade de telefone
  if (
    msg.includes('contacts_tenant_id_phone_key') ||
    (msg.includes('duplicate key') && msg.includes('phone')) ||
    (msg.includes('unique constraint') && msg.includes('phone'))
  ) {
    return 'Este telefone já está cadastrado em nossa base. Use outro número ou entre em contato com o suporte.';
  }

  // Duplicidade de e-mail
  if ((msg.includes('duplicate key') || msg.includes('unique constraint')) && msg.includes('email')) {
    return 'Este e-mail já está cadastrado. Use outro e-mail ou faça login na sua conta.';
  }

  // Slug / identificador de URL
  if (msg.includes('identificador') || msg.includes('slug') || msg.includes('já está em uso')) {
    return 'Este identificador de URL já está em uso. Escolha outro para continuar.';
  }

  // Duplicidade genérica
  if (msg.includes('duplicate key') || msg.includes('unique constraint') || msg.includes('violates')) {
    return 'Já existe um cadastro com essas informações. Verifique os dados e tente novamente.';
  }

  // Mensagens de validação amigáveis vindas da RPC — repassar
  const passthroughs = [
    'cnpj', 'cpf', 'cep', 'uf', 'cidade',
    'ramo', 'dor', 'país', 'pais',
    'pessoa física', 'pessoa jurídica', 'documento',
    'nome da empresa', 'plano inválido',
  ];
  if (passthroughs.some((k) => msg.includes(k))) {
    return raw;
  }

  // Fallback comercial
  return 'Não foi possível criar sua empresa agora. Tente novamente em alguns instantes ou fale com o suporte.';
}
